import React, { useEffect, useState } from "react";
import { Sun, Moon, Sparkles, Clock, Loader2, ShieldAlert } from "lucide-react";
import api from "../../lib/api";

const ROWS = [
  ["tithi", "Tithi", Moon],
  ["nakshatra", "Nakshatra", Sparkles],
  ["yoga", "Yoga", Sparkles],
  ["karana", "Karana", Sparkles],
  ["sunrise", "Sunrise", Sun],
  ["sunset", "Sunset", Sun],
  ["abhijit_muhurta", "Abhijit Muhurta", Clock],
  ["brahma_muhurta", "Brahma Muhurta", Clock],
];

// Live Panchang for Tarapith (default) — auspicious timings at a glance.
export default function PanchangCard({ compact = false }) {
  const [p, setP] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/astro/panchang")
      .then((r) => alive && setP(r.data))
      .catch(() => alive && setP(null));
    return () => { alive = false; };
  }, []);

  if (!p) {
    return (
      <div className="glass rounded-[1.5rem] p-7 flex items-center justify-center min-h-[220px]" data-testid="panchang-loading">
        <Loader2 className="h-6 w-6 animate-spin text-tara-teal" />
      </div>
    );
  }

  const rows = compact ? ROWS.slice(0, 6) : ROWS;

  return (
    <div className="glass-liquid relative overflow-hidden rounded-[1.5rem] p-7" data-testid="panchang-card">
      <span className="orb orb-gold h-40 w-40 -top-12 -right-8" />
      <div className="relative">
        <div className="mb-5 flex flex-wrap items-center gap-3">
          <span className="badge-gold inline-flex items-center gap-2 rounded-full px-3.5 py-1 text-[10px] font-serif uppercase tracking-[0.24em]">
            <Sun className="h-3 w-3 flame-flicker" /> Daily Panchang
          </span>
          <span className="text-[11px] uppercase tracking-[0.16em] text-tara-muted">
            {p.weekday} · {new Date(`${p.date}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}
          </span>
        </div>

        <p className="font-display text-2xl text-tara-ink mb-1">{p.tithi}</p>
        <p className="text-sm text-tara-body mb-6">
          Moon in {p.moon_sign} · Sun in {p.sun_sign} · Tarapith, Birbhum
        </p>

        <dl className="grid grid-cols-2 gap-x-6 gap-y-3.5">
          {rows.map(([key, label, Icon]) => (
            <div key={key} data-testid={`panchang-${key}`}>
              <dt className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.16em] text-tara-muted">
                <Icon className="h-3 w-3 text-tara-teal" /> {label}
              </dt>
              <dd className="text-sm font-semibold text-tara-ink">{p[key] || "—"}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-6 rounded-2xl border border-tara-vermilion/25 bg-tara-vermilion/[0.05] p-4" data-testid="panchang-rahu">
          <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.16em] text-tara-sindoor">
            <ShieldAlert className="h-3 w-3" /> Rahu Kaal · avoid new beginnings
          </p>
          <p className="mt-1 font-display text-lg text-tara-ink">{p.rahu_kaal || "—"}</p>
          {p.gulika_kaal && <p className="mt-1 text-xs text-tara-muted">Gulika Kaal: {p.gulika_kaal}</p>}
        </div>

        <p className="mt-4 text-[11px] leading-relaxed text-tara-muted">
          Calculated live with the Swiss Ephemeris (Lahiri ayanamsa) for Tarapith in IST. Local panchang may differ slightly.
        </p>
      </div>
    </div>
  );
}
